export default {
  title: "Architectures",
  create: "Créer une architecture",
  edit: "Modifier l'architecture",
  delete: "Supprimer l'architecture",
  duplicate: "Dupliquer l'architecture",
  rename: "Renommer l'architecture",
  fields: {
    name: "Nom de l'architecture",
    description: "Description",
    provider: "Fournisseur cloud",
    status: "Statut",
    version: "Version",
    lastModified: "Dernière modification",
    createdBy: "Créé par",
    estimatedCost: "Coût estimé"
  },
  status: {
    draft: "📝 Brouillon",
    validated: "✓ Validé",
    deployed: "🚀 Déployé"
  },
  providers: {
    azure: "Microsoft Azure",
    aws: "Amazon Web Services",
    gcp: "Google Cloud Platform"
  },
  messages: {
    createSuccess: "Architecture créée avec succès",
    updateSuccess: "Architecture mise à jour avec succès",
    deleteSuccess: "Architecture supprimée avec succès",
    duplicateSuccess: "Architecture dupliquée avec succès",
    renameSuccess: "Architecture renommée avec succès",
    createError: "Erreur lors de la création de l'architecture",
    updateError: "Erreur lors de la mise à jour de l'architecture",
    deleteError: "Erreur lors de la suppression de l'architecture",
    loadError: "Erreur lors du chargement de l'architecture",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette architecture ?"
  },
  empty: {
    title: "Aucune architecture",
    description: "Créez votre première architecture pour commencer",
    button: "Créer une architecture"
  },
  terraform: {
    generate: "Générer le code Terraform",
    download: "Télécharger Terraform",
    lastGenerated: "Dernière génération",
    generating: "Génération en cours..."
  },
  modals: {
    createArchitecture: {
      title: "Créer une nouvelle architecture",
      projectLabel: "Projet :",
      fields: {
        name: {
          label: "Nom de l'architecture *",
          placeholder: "Ex: Architecture Web App Production"
        },
        description: {
          label: "Description",
          placeholder: "Brève description de l'architecture..."
        },
        type: {
          label: "Type d'architecture",
          options: {
            webApp: "Web Application",
            microservices: "Microservices",
            dataProcessing: "Data Processing",
            iot: "IoT",
            machineLearning: "Machine Learning",
            serverless: "Serverless",
            containerOrchestration: "Container Orchestration",
            other: "Autre"
          }
        },
        deploymentType: {
          label: "Type de déploiement",
          hint: "Comment cette architecture sera déployée",
          options: {
            monoCloud: "Mono-cloud",
            multiCloud: "Multi-cloud",
            hybrid: "Hybride"
          }
        },
        template: {
          label: "Utiliser un template prédéfini",
          options: {
            blank: "Vierge",
            tier3: "Architecture 3-tier classique",
            microservicesK8s: "Microservices avec K8s",
            serverlessLambda: "Serverless AWS Lambda",
            dataPipeline: "Pipeline de données"
          }
        }
      },
      buttons: {
        cancel: "Annuler",
        create: "Créer l'architecture"
      },
      errors: {
        nameRequired: "Le nom de l'architecture est requis !"
      }
    },
    createProject: {
      title: "Créer un nouveau projet",
      fields: {
        name: {
          label: "Nom du projet *",
          placeholder: "Ex: Infrastructure Production"
        },
        description: {
          label: "Description",
          placeholder: "Brève description du projet..."
        },
        provider: {
          label: "Stratégie Cloud",
          hint: "Le fournisseur cloud principal pour ce projet",
          options: {
            azure: "Azure",
            aws: "AWS",
            gcp: "GCP",
            multiCloud: "Multi-cloud"
          }
        }
      },
      buttons: {
        cancel: "Annuler",
        create: "Créer le projet"
      },
      errors: {
        nameRequired: "Le nom du projet est requis !"
      }
    }
  }
};
